jQuery(function () {
  window.setTimeout(function () {
    jQuery("html").removeClass("is-animating");
    jQuery("html").attr("style", "");
  }, 30);
  var event;
  if (typeof Event === "function") {
    event = new Event("px-ready");
  } else {
    event = document.createEvent("Event");
    event.initEvent("px-ready", true, true);
  }
  window.dispatchEvent(event);
});

window.addEventListener("px-ready", function () {

  if(navigator.platform.indexOf('Win') > -1){
    jQuery('body').addClass('is-windows');
  }
  jQuery('body').attr('platform',navigator.platform);
  jQuery(document).on("click", 'a[href^="#"]', function (event) {
    console.log("scroller");
    if (!jQuery(this).hasClass("uk-accordion-title")) {
      event.preventDefault();

      var scrolltop = 0;
      if (
        jQuery(this).attr("href") != "#" &&
        jQuery(this).attr("data-noscrollup") != "1" &&
        jQuery(jQuery(this).attr("href")).length
      ) {
        scrolltop = jQuery(jQuery(this).attr("href")).offset().top;
      }

      jQuery("html, body").animate(
        {
          scrollTop: scrolltop,
        },
        350
      );
    }
  });

  var barCookieDate = localStorage.getItem('cookiebar-shown');
  var date = new Date();
  var today = date.getDate() + '-' + date.getMonth() + '-' + date.getFullYear();
  if(barCookieDate != today){
    jQuery('body').addClass('showCookieBar');
  }
  jQuery('.js-close-cookie-banner').click(function(){
    localStorage.setItem('cookiebar-shown',today);
    jQuery('body').removeClass('showCookieBar');
    return false;
  })
});
